/**
 * Public origin for SparkSeller Creator. Override with REACT_APP_CREATOR_URL.
 */
const CREATOR_PROD_URL = "https://creator.sparkseller.com";
const CREATOR_STAGING_URL = "https://sparkseller-creator-staging.web.app";

export { CREATOR_PROD_URL, CREATOR_STAGING_URL };

/**
 * Public origin for SparkSeller Creator. Override with REACT_APP_CREATOR_URL.
 */
export function getCreatorAppUrl() {
  const configured = process.env.REACT_APP_CREATOR_URL;
  if (configured) return configured.replace(/\/$/, "");

  const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
  if (projectId === "sparkseller-connect-prod") return CREATOR_PROD_URL;
  if (projectId === "sparkseller-connect-staging") return CREATOR_STAGING_URL;

  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "sparkseller.com" || host === "www.sparkseller.com" || host === "creator.sparkseller.com") {
      return CREATOR_PROD_URL;
    }
    if (host.includes("staging")) return CREATOR_STAGING_URL;
  }

  return CREATOR_PROD_URL;
}
